<ng-container *ngIf="(dataSourcePlayListVideosState$ | async) as state">
    <div class="video-playlist-wrapper">
        <div class="video-content" >
            <ng-container  *ngIf="videoPath">
                <app-new-video-player
                    [videoPath]="videoPath"></app-new-video-player>
                <app-comment-list
                    [videoId]="videoPath.id"
                ></app-comment-list>
            </ng-container>

            <ng-container *ngIf="!videoPath && state.videos.videos">
                <app-new-video-player
                    [videoPath]="state.videos.videos[0]">
                </app-new-video-player>
                <app-comment-list
                    [videoId]="state.videos.videos[0].id"
                ></app-comment-list>
            </ng-container>
        </div>

        <div class="video-playlist">
            <div class="playlist-desc">
                <div class="playlist-desc-name">
                    <h3>
                        <span class="naem">{{state.videos.name}}</span>
<!--                        <span class="playlist-video-count">1/30</span>-->
                    </h3>
                </div>
                <div class="playlist-privacy">
                <span>

                </span>
                    <span>
                    Private
                </span>
                </div>
            </div>
            <div class="video-list">
                <div class="video-list-item" *ngFor="let video of state.videos.videos;let i = index">
                    <input
                        type="radio"
                        name="videos"
                        [defaultChecked]="(i === 0)"
                        (change)="getPLayVideoData(video)"
                        [id]="video.id">
                    <label [for]="video.id">
                        <div class="video-state">
                            <div class="video-cover">
                                <!--                            <img src="assets/testVideo.png" alt="">-->
                                <img [src]="video?.thumbnail|getImgPath:'images'" alt="">
                            </div>

                            <div class="video-name">
                                <p class="video-name-text">{{video.name}}</p>
                            </div>
                        </div>
                        <div class="video-view">
                            <span class="material-symbols-outlined">
                                visibility
                            </span>
                            <span>{{video?.views}} views</span>
                        </div>
                    </label>

                </div>
            </div>

        </div>
    </div>
</ng-container>



